// src/components/InsuranceDossierButton.jsx
// Bouton « Dossier d'assurance » (§5/§17) au niveau collection.
// Charge œuvres (artworks_secure, RLS) + polices existantes (table insurance) puis génère
// la cédule PDF. i18n à faire (FR pour l'instant).
import React, { useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { generateInsuranceDossier } from "../utils/insuranceDossierPdf";

export default function InsuranceDossierButton({ collectionId, collectionName = "", ownerName = "", className = "" }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!collectionId || busy) return;
    setBusy(true);
    try {
      const { data: artworks, error: aErr } = await supabase
        .from("artworks_secure")
        .select("id,title,artist,current_estimated_value,valuation_estimated_value,estimated_value,value,condition,storage_location_detail,insurance_status")
        .eq("collection_id", collectionId);
      if (aErr) throw aErr;

      const ids = (artworks || []).map((a) => a.id);
      const insByArtwork = {};
      if (ids.length) {
        const { data: rows } = await supabase
          .from("insurance")
          .select("artwork_id, insurer, insurance_type, value, expiry_date, idnumber_insurance")
          .in("artwork_id", ids);
        for (const r of rows || []) {
          // garde la police la plus récente / valide par œuvre
          if (!insByArtwork[r.artwork_id]) insByArtwork[r.artwork_id] = r;
        }
      }

      generateInsuranceDossier({ collectionName, ownerName, artworks: artworks || [], insByArtwork });
    } catch (e) {
      console.error("[InsuranceDossierButton]", e);
      window.alert("Impossible de générer le dossier d'assurance.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy || !collectionId}
      title="Générer une cédule d'assurance (inventaire, valeur à assurer, état, polices)"
      className={className || "inline-flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-50 disabled:opacity-60"}
    >
      {busy ? "Préparation…" : "Dossier d'assurance (PDF)"}
    </button>
  );
}
